import React from "react";
import { Button, Card } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import IntlMessages from "../../util/IntlMessages";
import { useHistory } from "react-router-dom";
import { StringIsNullOrEmpty } from "../../appRedux/actions";
const GeneralCard = (props) => {
  
  const history = useHistory();
  const IsButtonDisable = props && props.IsButtonDisable ? props.IsButtonDisable : false;
  const ImageIcon = props && props.ImageIcon ? props.ImageIcon : "gx-smart-img";

  function redirectToLink(link) {
    if (!StringIsNullOrEmpty(link)) {
      if (link.includes("https:")) {
        window.open(link, "_blank");
      } else {
        history.push(link);
      }
    }
  }
  return (
    <Card  className='gx-card announcement-card'>
      <img className={ImageIcon} alt="example" src={props.Image} />
      <div className="gx-text-center cen-txt-wid">
        <h2 className="mb-0">{props.Heading}</h2>
        <p className="gx-mb-3 dk-inventorycard-des">{props.Content}</p>
        <div
          className="gx-link gx-btn-link dk-pd-16"
          onClick={() => {
            redirectToLink(props.Link)
          }}
        >
          {props.LinkText} {props.LinkIcon}
        </div>
        {props.IsNotButton ? (
          <Button
          type="primary"
          size="large"
            className="mb-3 dk-btn-cancel"
            icon={<ClockCircleOutlined className="dk-btn-icon-align" />}
            disabled={IsButtonDisable}
          >
            {props.NotButtonText}
          </Button>
        ) : (
          ""
        )}
      </div>
    </Card>
  );
};

export default GeneralCard;
